import styled from 'styled-components';
import { rem } from 'polished';
import { TitleWithBenefitsStyled } from '../../TitleWithBenefitsStyled';

export const TitleWithBenefitsStyledOVGB = styled(TitleWithBenefitsStyled)`
    .title {
        font-size: ${rem(30)};
        font-weight: ${({ theme }) => theme.fontWeights.textExtraBold};
        text-transform: uppercase;
    }
    .specs .specs-title {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        font-weight: ${({ theme }) => theme.fontWeights.textLight};
    }
    .benefits {
        background: none;
        padding: 0;

        .heading {
            color: ${({ theme }) => theme.colors.grey27};
        }
        .bullet-points {
            list-style: disc;
            margin: 0;
            padding: ${rem(2)} 0 ${rem(20)} ${rem(16)};

            &.allow-bullet-points {
                padding-left: ${rem('16px')};
            }
        }

        svg {
            g {
                circle {
                    fill: ${({ theme }) => theme.colors.black2};
                    stroke: ${({ theme }) => theme.colors.black2};
                }

                line {
                    stroke: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }
`;
